export default __webpack_public_path__ + "static/media/verifiedico.1f361fcc.png";